import React from 'react';
import { ShieldCheckIcon, BadgeCheckIcon, DownloadIcon, LockIcon, HeadphonesIcon } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: ShieldCheckIcon,
    text: 'Pago Seguro'
  }, {
    icon: BadgeCheckIcon,
    text: 'Garantía'
  }, {
    icon: DownloadIcon,
    text: 'Descarga Inmediata'
  }, {
    icon: LockIcon,
    text: 'Protección de Datos'
  }, {
    icon: HeadphonesIcon,
    text: 'Soporte'
  }];
  return <div className="bg-dark-light border-y border-white/5 py-6 px-4" data-id="element-200">
      <div className="max-w-6xl mx-auto flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-201">
        {items.map((item, index) => {
        const Icon = item.icon;
        return <div key={index} className="flex items-center gap-2 text-gray-400" data-id="element-202">
              <Icon className="w-5 h-5 text-green-500" data-id="element-203" />
              <span className="text-sm font-medium" data-id="element-204">{item.text}</span>
            </div>;
      })}
      </div>
    </div>;
}